<template>
  <div
    class="overflow-hidden rounded-xl"
  >
    <div v-if="innerStep === 0">
      <div>
        <img
          src="../../../../assets/images/merch-banner.jpg"
          class="w-full h-full"
        >
      </div>
      <div class="flex-1">
        <div class="py-5 px-14 text-center">
          <BaseText
            type="label"
            size="lg"
            class="text-text-loud"
          >
            Snap some merch for free!
          </BaseText>
          <BaseText
            class="text-text-normal space-y-3 mt-3"
            size="sm"
          >
            <div>
              We work incredibly hard building Foreplay and your support means we can keep going!
            </div>
            <div>
              If you have 2 minutes it would mean the world if you could write us a review.
            </div>
            <div class="text-text-muted">
              In return I would love to send you some Foreplay merch.
            </div>
          </BaseText>
        </div>
        <div class="flex items-center justify-center p-5">
          <div class="grid grid-cols-12">
            <div
              v-for="(step,index) in MERCH_STEPS"
              :key="step"
              class="w-40 col-span-4 flex items-center justify-center flex-col gap-3 relative"
            >
              <div
                v-if="index === 1"
                class="w-24 bg-border-normal absolute top-2.5"
                style="left: -48px; height: 1px"
              />
              <div
                v-if="index === 1"
                class="w-24 bg-border-normal absolute top-2.5"
                style="right: -48px; height: 1px"
              />
              <div
                class="rounded-full px-1 py-0.5 w-6 h-6 flex items-center justify-center"
                :class="index === 0 ? 'bg-text-muted text-white' : 'border border-border-normal text-text-disabled'"
              >
                <BaseText
                  type="label"
                  size="xs"
                >
                  {{ index+1 }}
                </BaseText>
              </div>
              <div class="p-2 text-center">
                <BaseText
                  type="label"
                  size="sm"
                  class="text-text-muted"
                >
                  {{ step }}
                </BaseText>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-else-if="innerStep === 1"
      class="rounded-XL overflow-hidden"
    >
      <div class="p-2.5">
        <iframe
          src="https://foreplayos.notion.site/ebd/1e325afdb41e802998ded4db746df37c"
          width="100%"
          height="600"
          frameborder="0"
          allowfullscreen
        />
      </div>
      <div class="py-2.5 text-center">
        <BaseText
          size="sm"
          class="text-text-normal"
        >
          ** Make sure you hit “Submit on the form embedded above **
        </BaseText>
      </div>
    </div>

    <!-- Footer -->
    <div class="px-5 pb-5 flex flex-col gap-3 items-center">
      <button
        class="black-btn-primary w-full px-2.5 py-2 rounded-md"
        @click="handleStep"
      >
        <BaseText
          type="label"
          size="sm"
          class="text-white"
        >
          {{ innerStep === 0 ? 'Write a review' : "I'm Done!" }}
        </BaseText>
      </button>
      <button
        class="hover:bg-background-normal rounded-md w-max py-2 px-2.5"
        @click="$emit('next')"
      >
        <BaseText
          type="label"
          size="sm"
          class="text-text-muted"
        >
          {{ innerStep === 0 ? "No thanks" : "I changed my mind, no merch" }}
        </BaseText>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MerchReviewOffer',
  data () {
    const MERCH_STEPS = [
      'Click the below button.',
      'Write a review on G2 or Chrome Store.',
      'Submit your merch request.'
    ]
    return {
      MERCH_STEPS,

      innerStep: 0
    }
  },
  methods: {
    handleStep () {
      if (this.innerStep === 0) {
        this.innerStep += 1
      } else {
        this.$emit('next')
      }
    }
  }
}
</script>
